document.documentElement.classList.remove('no-js');

document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.hidden = expanded;
  });
});

document.querySelectorAll('[data-quantity]').forEach((field) => {
  field.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    const input = field.querySelector('input');
    if (!button || !input) return;
    const next = Number(input.value || 1) + Number(button.dataset.step || 0);
    input.value = String(Math.max(1, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

const vgMoney = (cents) => {
  const currency = window.Shopify?.currency?.active || 'USD';
  return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency
  }).format(Number(cents || 0) / 100);
};

const vgInitProduct = (root) => {
  if (root.dataset.interactive === 'true') return;
  root.dataset.interactive = 'true';

  const form = root.querySelector('[data-product-form]');
  const variantSelect = root.querySelector('[data-variant-select]');
  const sticky = root.querySelector('[data-sticky-product]');
  const stickySelect = root.querySelector('[data-sticky-variant]');
  const stickySubmit = root.querySelector('[data-sticky-submit]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const price = root.querySelector('[data-product-price]');
  const compare = root.querySelector('[data-product-compare]');
  const stickyPrice = root.querySelector('[data-sticky-price]');
  const stock = root.querySelector('[data-stock-status]');
  const notification = root.querySelector('[data-cart-notification]');
  const notificationMessage = root.querySelector('[data-cart-message]');
  const variantsNode = root.querySelector('[data-product-variants]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];

  const currentVariant = () => {
    const selectedId = variantSelect?.value || form?.querySelector('[name="id"]')?.value;
    return variants.find((variant) => String(variant.id) === String(selectedId)) || variants[0];
  };

  const updateVariant = (variant, announce = false) => {
    if (!variant) return;
    if (variantSelect) variantSelect.value = String(variant.id);
    if (stickySelect) stickySelect.value = String(variant.id);
    if (price) price.textContent = vgMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = vgMoney(variant.price);
    if (compare) {
      const showCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      compare.hidden = !showCompare;
      compare.textContent = showCompare ? vgMoney(variant.compare_at_price) : '';
    }
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldOutLabel;
    }
    if (stickySubmit) {
      stickySubmit.disabled = !variant.available;
      stickySubmit.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldOutLabel;
    }
    if (stock) stock.textContent = variant.available ? root.dataset.readyLabel : root.dataset.soldOutLabel;
    if (announce) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      window.dataLayer?.push({
        event: 'select_item',
        ecommerce: { items: [{ item_id: String(variant.id), item_name: root.dataset.productTitle, price: Number(variant.price) / 100 }] }
      });
    }
  };

  variantSelect?.addEventListener('change', () => updateVariant(currentVariant(), true));
  stickySelect?.addEventListener('change', () => {
    if (variantSelect) {
      variantSelect.value = stickySelect.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  stickySubmit?.addEventListener('click', () => form?.requestSubmit(addButton));

  if (sticky && form && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || window.scrollY < 320;
    }, { threshold: 0.15 });
    observer.observe(form);
  }

  form?.addEventListener('submit', async (event) => {
    if (!event.submitter?.matches('[data-add-to-cart]')) return;
    event.preventDefault();
    const variant = currentVariant();
    addButton.disabled = true;
    addButton.classList.add('is-loading');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((cartResponse) => cartResponse.json());
      document.querySelectorAll('[data-cart-count]').forEach((count) => {
        count.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
      });
      if (notificationMessage) notificationMessage.textContent = notification?.dataset.addedLabel || 'Added to your cart.';
      if (notification) {
        notification.hidden = false;
        window.setTimeout(() => { notification.hidden = true; }, 5000);
      }
      window.dataLayer?.push({
        event: 'add_to_cart',
        ecommerce: { currency: window.Shopify?.currency?.active || 'USD', value: Number(variant?.price || 0) / 100, items: [{ item_id: String(variant?.id || ''), item_name: root.dataset.productTitle, price: Number(variant?.price || 0) / 100, quantity: Number(form.elements.quantity?.value || 1) }] }
      });
    } catch (error) {
      if (notificationMessage) notificationMessage.textContent = error.message;
      if (notification) notification.hidden = false;
    } finally {
      addButton.classList.remove('is-loading');
      updateVariant(currentVariant());
    }
  });

  root.querySelector('[data-cart-notification-close]')?.addEventListener('click', () => {
    if (notification) notification.hidden = true;
  });

  const galleryButton = root.querySelector('[data-gallery-open]');
  const galleryItems = Array.from(root.querySelectorAll('[data-gallery-thumbnail]'));
  const galleryMainImage = root.querySelector('.vg-product__gallery-main-image');
  const dialog = root.querySelector('[data-gallery-dialog]');
  const dialogImage = root.querySelector('[data-gallery-image]');
  let galleryIndex = Math.max(0, galleryItems.findIndex((item) => item.getAttribute('aria-current') === 'true'));
  const selectGalleryImage = (index) => {
    if (!galleryItems.length) return;
    galleryIndex = (index + galleryItems.length) % galleryItems.length;
    const item = galleryItems[galleryIndex];
    galleryItems.forEach((thumbnail, thumbnailIndex) => {
      if (thumbnailIndex === galleryIndex) thumbnail.setAttribute('aria-current', 'true');
      else thumbnail.removeAttribute('aria-current');
    });
    if (galleryMainImage) {
      galleryMainImage.removeAttribute('srcset');
      galleryMainImage.removeAttribute('sizes');
      galleryMainImage.src = item.dataset.mainImageUrl || item.dataset.imageUrl;
      galleryMainImage.alt = item.dataset.imageAlt || '';
    }
    galleryButton?.setAttribute('aria-label', item.getAttribute('aria-label') || '');
  };
  const showGalleryImage = (index) => {
    if (!galleryItems.length || !dialogImage) return;
    galleryIndex = (index + galleryItems.length) % galleryItems.length;
    const item = galleryItems[galleryIndex];
    dialogImage.src = item.dataset.imageUrl;
    dialogImage.alt = item.dataset.imageAlt || '';
  };
  galleryItems.forEach((item, index) => item.addEventListener('click', () => selectGalleryImage(index)));
  galleryButton?.addEventListener('click', () => {
    showGalleryImage(galleryIndex);
    dialog?.showModal();
  });
  root.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog?.close());
  root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => showGalleryImage(galleryIndex - 1));
  root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showGalleryImage(galleryIndex + 1));
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
};

document.querySelectorAll('[data-product-root]').forEach(vgInitProduct);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-product-root]').forEach(vgInitProduct);
});
